import React from "react";
import { Modal, Row, Col } from "react-bootstrap";
import './TaskDetailsModal.css';

const TaskDetailsModal = ({ show, onHide, taskData }) => {
  const {
    taskId,
    caseId,
    priority,
    status,
    category,
    type,
    subtype,
    targetDate,
    remarks,
    assignedTo,
    createdBy,
    createdAt,
    updatedAt,
  } = taskData;

  // Choose label dynamically
  const fileSectionTitle =
    category?.toLowerCase().includes("video")
      ? "Video"
      : category?.toLowerCase().includes("image")
      ? "Image"
      : "Document";

  return (
    <Modal show={show} onHide={onHide}  size="lg" className="task-modal" dialogClassName="custom-modal-width">
      <Modal.Body>

        {/* HEADER */}
        <div className="d-flex justify-content-between align-items-start mb-3">
          <div>
            <div className="d-flex align-items-center gap-3">
                <h5 className="fw-bold">{taskId}</h5>
                {/* TAGS */}
                <div className="d-flex gap-2">
                    <span className="badge bg-danger text-uppercase">{priority}</span>
                    <span className="badge bg-success text-uppercase">{status}</span>
                </div>
            </div>
            <small className="text-muted">Case ID: {caseId}</small>
          </div>

          <button className="btn btn-link text-dark fs-4" onClick={onHide}>
            ×
          </button>
        </div>

        {/* DETAILS GRID */}
        <Row className="mb-4">
          <Col md={6}>
            <div className="label">Category</div>
            <div className="value">{category}</div>
          </Col>

          <Col md={6}>
            <div className="label">Type</div>
            <div className="value">{type}</div>
          </Col>

          <Col md={6} className="mt-3">
            <div className="label">Subtype</div>
            <div className="value">{subtype}</div>
          </Col>

          <Col md={6} className="mt-3">
            <div className="label">Target Date</div>
            <div className="value">{targetDate}</div>
          </Col>
        </Row>

        <hr />

        {/* REMARKS */}
        <div className="section-title mb-1">Remarks from Admin</div>
        <p className="text-muted">{remarks}</p>

        <hr />

        {/* FOOTER DETAILS */}
        <Row className="mt-3 mb-4">
          <Col md={6}>
            <div className="label">Assigned To</div>
            <div className="value">{assignedTo}</div>
          </Col>

          <Col md={6}>
            <div className="label">Created By</div>
            <div className="value">{createdBy}</div>
          </Col>

          <Col md={6} className="mt-3">
            <div className="label">Created At</div>
            <div className="value">{createdAt}</div>
          </Col>

          <Col md={6} className="mt-3">
            <div className="label">Updated At</div>
            <div className="value">{updatedAt}</div>
          </Col>
        </Row>

      </Modal.Body>
    </Modal>
  );
};

export default TaskDetailsModal;
